import React, { useEffect, useState } from 'react';
import { Search, ChevronRight } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { encryptPayload } from '../utils/encryption';

export default function Recipient() {
  const navigate = useNavigate();
  const location = useLocation();
  const paramsdata = location.state;

  // CHANGED: Choosepayment now sends 'sendmoneycurrency' to avoid conflict with beneficiary 'currency'
  // but we keep reading all params transparently - this page can also come from other routes
  const currency = paramsdata?.sendmoneycurrency ?? paramsdata?.currency;
  const transferflowamount = paramsdata?.transferflowamount;
  const currencyid = paramsdata?.currencyid;
  const balance = paramsdata?.balance;
  const buyAmount = paramsdata?.buyAmount;
  const contactId = paramsdata?.contactId;
  const from_currency = paramsdata?.from_currency;
  const from_amount = paramsdata?.from_amount;
  // CHANGED: read Nav_node transparently - may come as Nav_node or sendmoney_Nav_node
  const Nav_node = paramsdata?.Nav_node ?? paramsdata?.sendmoney_Nav_node;
  const exchangeRate = paramsdata?.exchangeRate;
  const nodeType = 'Recipient';

  // These are the receive currency values for the send money flow context
  const receiveCurrencyValue = currency;

  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(buyAmount);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [selectedbeneficiary, setselectedbeneficiary] = useState('');
  const [selectedbeneficiaryCode, setselectedbeneficiaryCode] = useState('');
  const [
    selectedbeneficiaryBankAccoutNumber,
    setselectedbeneficiaryBankAccoutNumber,
  ] = useState('');
  const [selectedbeneficiaryType, setselectedbeneficiaryType] = useState('');
  const [selectedbeneficiaryId, setselectedbeneficiaryId] = useState('');
  const [selectedbeneficiaryCountry, setselectedbeneficiaryCountry] =
    useState('');
  const [
    selectedbeneficiaryBankAccountId,
    setselectedbeneficiaryBankAccountId,
  ] = useState('');
  const [selectedbeneficiaryBeneType, setselectedbeneficiaryBeneType] =
    useState('');
  const [selectedbeneficiaryBankType, setselectedbeneficiaryBankType] =
    useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [showAll, setShowAll] = useState(false);
  const sendmoneynode = 7;

  // ADDED: balances state needed for getAvailableBalance used in navigate calls
  const [balances, setBalances] = useState([]);
  const [usedBalances, setusedBalances] = useState([]);

  const beneficiaryLists = [];

  useEffect(() => {
    getData();
    removeData();
    getBalances();

    if (Nav_node === 2) {
      setBeneficiaries([]);
      beneficiaryList();
    } else {
      beneficiaryList();
    }
  }, [Nav_node]);

  // ADDED: load balances so getAvailableBalance works correctly in navigate calls
  const getBalances = async () => {
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    try {
      const resp = await axios.get(
        Constants.BASE_URL +
          'API-FX-231-GET-WALLET-BALANCES/' +
          login_workspaces_id,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      const balArray = Object.values(resp.data);
      setusedBalances(resp.data.used_balances);
      balArray.pop();
      balArray.pop();
      balArray.pop();
      balArray.pop();
      if (balArray.length > 0) {
        setBalances(balArray);
      }
    } catch (err) {
      console.log(err.response?.data || err);
    }
  };

  // ADDED: getAvailableBalance - used in navigate calls to BeneficiaryTypes
  const getAvailableBalance = (currencyCode) => {
    const balanceObj = balances.find((b) => b.currency === currencyCode);
    if (!balanceObj) return 0;
    const used = usedBalances[currencyCode] || 0;
    const available = parseFloat(balanceObj.balance) - parseFloat(used);
    return available < 0 ? 0 : available;
  };

  const getData = async () => {
    if (transferflowamount != '' && transferflowamount != null) {
      setAmount(transferflowamount);
      sessionStorage.setItem('receive', JSON.stringify(currencyid));
    }
  };

  const removeData = async () => {
    sessionStorage.removeItem('send');
    sessionStorage.removeItem('receive');
  };

  const getClearbankBene = async (token, workspaceId) => {
    const encryptedPayload = await encryptPayload({ workspace_id: workspaceId,platform: 'web',
              extraParamValidation: 'trustedfromweb' });
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-191-CLEAR-BANK-LIST-BENEFICIARY',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + JSON.parse(token),
          },
        },
      )
      .then((resp) => {
        resp.data.data.forEach((element) => {
          beneficiaryLists.push({
            id: element.id,
            display_name: element.beneficiaryName,
            bank_account_number: element.banks[0].accountNumber,
            country_flag: Constants.FXMASTER_BASE_URL + 'flags/UK.png',
            avatar: '',
            code: element.banks[0].sortCode,
            bank_code_type: 'sort_code',
            type: 'Sort Code',
            country: element.country,
            bank_account_name: '',
            bank_account_id: element.banks[0].id,
            bene_type: element.type,
            bank_type: 'clear_bank',
          });
        });

        axios
          .get(`${Constants.BASE_URL}API-FX-126-ListBeneficiary`, {
            params: {
              workspace_id: workspaceId,
              reference_type: 'money_transfer',
              country_id: currencyid,
            },
            headers: {
              fx_key: Constants.SUBSCRIPTION_KEY,
              Authorization: `Bearer ${JSON.parse(token)}`,
            },
          })
          .then((response) => {
            response.data.data.forEach((element) => {
              beneficiaryLists.push({
                id: element.id,
                display_name: element.display_name,
                bank_account_number:
                  element.meta.bank_account_number != null &&
                  element.meta.bank_account_number != ''
                    ? element.meta.bank_account_number
                    : element.meta.iban,
                country_flag: Constants.FXMASTER_BASE_URL + 'flags/UK.png',
                avatar: '',
                code:
                  element.meta.bic_number ??
                  element.meta.aba_number ??
                  element.meta.aba_number ??
                  element.meta.sort_code ??
                  element.meta.branch_code ??
                  element.meta.bsb_number ??
                  element.meta.bank_code ??
                  element.meta.ifsc_code ??
                  element.meta.routing_code_value_1,
                bank_code_type: 'sort_code',
                type: 'Sort Code',
                country: element.meta.bank_country,
                bank_account_name: '',
                bank_account_id: element.id,
                bene_type: element.type,
                bank_type: 'currency_cloud',
              });
            });
            setLoading(false);
          })
          .catch((error) => {
            console.log(error.response);
            setLoading(false);
          });

        setBeneficiaries(beneficiaryLists);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getCCBene = async (token, workspaceId) => {
    try {
      const response = await axios.get(
        `${Constants.BASE_URL}API-FX-126-ListBeneficiary`,
        {
          params: {
            workspace_id: workspaceId,
            reference_type: 'money_transfer',
            country_id: currencyid,
          },
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        },
      );

      const countryCodeMapping = {
        105: 'ifsc_code',
        234: 'aba_number',
        231: 'sort_code',
        38: 'branch_code',
        13: 'bsb_number',
        2: 'iban_number',
        1: 'iban_number',
        55: 'iban_number',
        114: 'iban_number',
        115: 'iban_number',
        129: 'iban_number',
        158: 'iban_number',
        177: 'iban_number',
        198: 'iban_number',
        59: 'iban_number',
        95: 'iban_number',
        100: 'iban_number',
        193: 'iban_number',
        249: 'iban_number',
      };

      const beneficiaryLists = response.data.data
        .filter((element) => countryCodeMapping[element.meta.bank_country])
        .map((element) => ({
          id: element.id,
          display_name: element.display_name,
          bank_account_number:
            element.meta.bank_account_number != null &&
            element.meta.bank_account_number != ''
              ? element.meta.bank_account_number
              : element.meta.iban,
          country_flag: element.country_flag,
          avatar: element.avatar,
          code:
            element.meta.bic_number ??
            element.meta.aba_number ??
            element.meta.aba_number ??
            element.meta.sort_code ??
            element.meta.branch_code ??
            element.meta.bsb_number ??
            element.meta.bank_code ??
            element.meta.ifsc_code ??
            element.meta.routing_code_value_1,
          bank_code_type: element.meta.bank_code_type,
          type: element.type,
          country: element.meta.beneficiary_address,
          bank_account_name: element.meta.bank_account_name,
          bank_account_id: '',
          bene_type: element.type,
          bank_type: 'currency_cloud',
        }));

      setBeneficiaries((beneficiaries) => [...beneficiaries, beneficiaryLists]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const beneficiaryList = async () => {
    setLoading(true);
    const token = sessionStorage.getItem('login_token');
    const workspaceId = sessionStorage.getItem('login_workspaces_id');

    if (currencyid == 231) {
      await getClearbankBene(token, workspaceId);
      await getCCBene(token, workspaceId);
    } else {
      await getCCBene(token, workspaceId);
    }
  };

  const toggleBeneficiarySelection = async (
    display_name,
    code,
    bank_account_number,
    type,
    beneficiaryid,
    country,
    bank_account_id,
    bene_type,
    bank_type,
  ) => {
    if (selectedbeneficiaryId === beneficiaryid) {
      setselectedbeneficiary('');
      setselectedbeneficiaryCode('');
      setselectedbeneficiaryBankAccoutNumber('');
      setselectedbeneficiaryType('');
      setselectedbeneficiaryId('');
      setselectedbeneficiaryCountry('');
      setselectedbeneficiaryBankAccountId('');
      setselectedbeneficiaryBeneType('');
      setselectedbeneficiaryBankType('');
    } else {
      setselectedbeneficiary(display_name.toUpperCase());
      setselectedbeneficiaryCode(code);
      setselectedbeneficiaryBankAccoutNumber(bank_account_number);
      setselectedbeneficiaryType(type);
      setselectedbeneficiaryId(beneficiaryid);
      setselectedbeneficiaryCountry(country);
      setselectedbeneficiaryBankAccountId(bank_account_id);
      setselectedbeneficiaryBeneType(bene_type);
      setselectedbeneficiaryBankType(bank_type);
    }
  };

  const proceedToPay = async (e) => {
    e.stopPropagation();

    const Enteramount = parseFloat(amount);
    if (Enteramount == 0 || Enteramount == '' || Enteramount == null) {
      toast.error('Please enter a valid amount');
    } else {
      let balanceValue = balance;
      if (typeof balanceValue === 'string') {
        balanceValue = balanceValue.split(',').join('');
      }
      balanceValue = parseFloat(balanceValue).toFixed(2);

        navigate('/SendMoneyPaymentConfirmation', {
          state: {
            name: selectedbeneficiary,
            ifsc: selectedbeneficiaryCode,
            Node: 'node_2',
            account: selectedbeneficiaryBankAccoutNumber,
            type: selectedbeneficiaryType,
            id: selectedbeneficiaryId,
            bank_account_name: selectedbeneficiary,
            currencyid: currencyid,
            currency: currency,
            amount: amount,
            bank_account_id: selectedbeneficiaryBankAccountId,
            country: selectedbeneficiaryCountry,
            bene_type: selectedbeneficiaryBeneType,
            bank_type: selectedbeneficiaryBankType,
            contactId: contactId,
            exchangeRate: exchangeRate,
            from_currency: from_currency,
            from_amount: from_amount,
          },
        }); 
    }
  };

  const getInitials = (name) => {
    if (!name) return '??';
    const nameParts = name.trim().split(' ');
    if (nameParts.length === 1)
      return nameParts[0].substring(0, 2).toUpperCase();
    return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
  };

  const getBeneficiariesList = () => {
    if (currencyid == 231) {
      return beneficiaries;
    } else {
      return Array.isArray(beneficiaries[0]) ? beneficiaries[0] : [];
    }
  };

  const allFilteredBeneficiaries = getBeneficiariesList().filter(
    (beneficiary) => {
      if (!searchQuery) return true;
      const query = searchQuery.toLowerCase();
      return (
        beneficiary.display_name?.toLowerCase().includes(query) ||
        beneficiary.bank_account_number?.toLowerCase().includes(query) ||
        beneficiary.code?.toLowerCase().includes(query)
      );
    },
  );
  const filteredBeneficiaries = showAll
    ? allFilteredBeneficiaries
    : allFilteredBeneficiaries.slice(0, 10);

  return (
    <div className="w-full min-h-screen bg-[#f1f5f9] px-6 py-4">
      <div className="min-h-screen shadow-md rounded-xl pm-page-bg mx-3 my-4 p-6">
        <ToastContainer />
        <div className="max-w-[80%] mx-auto">
          <h2 className="text-2xl font-semibold text-slate-800 mb-6">
            Select a Recipient
          </h2>

          <div className="flex items-center w-full gap-4 mb-6">
            <div className="flex-1 w-[70%] flex items-center bg-white rounded-xl px-4 py-3 border border-[#DEDCE1]  transition-all duration-200 ease-in-out  hover:border-blue-500  hover:ring-2 hover:ring-blue-200  focus-within:border-blue-600  focus-within:ring-2 focus-within:ring-blue-300">
              <Search className="text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Search by name..."
                className="ml-3 w-full bg-transparent outline-none text-gray-600 placeholder-gray-400"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <button
              className="py-3 px-6 rounded-2xl w-[30%] text-white text-sm font-medium 
            border border:1px solid var(--pm-border) pm-continue 
            shadow-lg shadow-blue-900/30 whitespace-nowrap"
              onClick={() =>
                navigate('/BeneficiaryTypes', {
                  state: {
                    currency: currency,
                    currencyid: currencyid,
                    // ADDED: use getAvailableBalance like original code
                    balance: receiveCurrencyValue
                      ? getAvailableBalance(receiveCurrencyValue).toLocaleString()
                      : '-',
                    transferflowamount: amount,
                    nodeType: nodeType,
                    sendmoneynode: sendmoneynode,
                    buyAmount: buyAmount,
                    exchangeRate: exchangeRate,
                    contactId: contactId,
                    from_currency: from_currency,
                    from_amount: from_amount,
                    sendmoney_Nav_node: 2,
                  },
                })
              }
            >
              + Add Recipient
            </button>
          </div>

          {loading ? (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <p className="mt-4 text-gray-600">Loading beneficiaries...</p>
            </div>
          ) : filteredBeneficiaries && filteredBeneficiaries.length > 0 ? (
            <>
              {filteredBeneficiaries.map((beneficiary, index) => {
                const isSelected = selectedbeneficiaryId === beneficiary.id;

                return (
                  <div
                    key={index}
                    className={`bg-[#fbfdff] rounded-2xl p-5 mb-4 shadow-md cursor-pointer transition-all duration-200 ease-in-out hover:border-blue-500 hover:ring-2 hover:ring-blue-200 ${isSelected ? 'border border-blue-600 ring-2 ring-blue-300' : 'border border-transparent'}`}
                    onClick={() =>
                      toggleBeneficiarySelection(
                        beneficiary.display_name,
                        beneficiary.code,
                        beneficiary.bank_account_number,
                        beneficiary.type,
                        beneficiary.id,
                        beneficiary.country,
                        beneficiary.bank_account_id,
                        beneficiary.bene_type,
                        beneficiary.bank_type,
                      )
                    }
                  >
                    <div className="flex justify-between items-center">
                      <div className="flex items-center">
                        <div
                          className="w-14 h-14 rounded-full bg-blue-100 
                        flex items-center justify-center 
                        text-blue-700 font-semibold text-xl mr-4"
                        >
                          {getInitials(beneficiary.display_name)}
                        </div>

                        <div>
                          <h3 className="text-lg font-semibold text-slate-800">
                            {beneficiary.display_name}
                          </h3>
                          <p className="text-sm text-gray-600">
                            {beneficiary.type} • {beneficiary.country}
                          </p>
                          <p className="text-sm text-gray-600">
                            {beneficiary.bank_account_number} • (
                            {beneficiary.code})
                          </p>
                        </div>
                      </div>
                      {isSelected ? (
                        <button
                          onClick={proceedToPay}
                          className="px-6 py-2 rounded-xl text-white text-sm font-medium 
                        border border:1px solid var(--pm-border) pm-continue 
                        shadow-lg shadow-blue-900/30 whitespace-nowrap"
                        >
                          Proceed
                        </button>
                      ) : (
                        <div className="w-11 h-11 rounded-full flex items-center justify-center bg-gray-200">
                          <ChevronRight className="w-5 h-5 text-gray-500" />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}

              {!showAll &&
                !selectedbeneficiary &&
                allFilteredBeneficiaries.length > 10 && (
                  <button
                    onClick={() => setShowAll(true)}
                    className="w-[250px] py-4 rounded-2xl ml-60 pm-continue text-lg font-medium 
                bg-white border-2 border:1px solid var(--pm-border) shadow-md "
                  >
                    View All ({allFilteredBeneficiaries.length} beneficiaries)
                  </button>
                )}

              {showAll && allFilteredBeneficiaries.length > 10 && (
                <button
                  onClick={() => setShowAll(false)}
                  className="w-[250px] py-4 rounded-2xl ml-60 pm-continue text-lg font-medium 
                bg-white border-2 border:1px solid var(--pm-border) shadow-md "
                >
                  Show Less
                </button>
              )}
            </>
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-600">No beneficiaries found</p>
              <button
                className="mt-4 text-blue-600 font-semibold"
                onClick={() =>
                  navigate('/BeneficiaryTypes', {
                    state: {
                      currency: currency,
                      currencyid: currencyid,
                      // ADDED: use getAvailableBalance like original code
                      balance: receiveCurrencyValue
                        ? getAvailableBalance(receiveCurrencyValue).toLocaleString()
                        : '-',
                      transferflowamount: amount,
                      nodeType: nodeType,
                      sendmoneynode: sendmoneynode,
                      buyAmount: buyAmount,
                      exchangeRate: exchangeRate,
                      contactId: contactId,
                      from_currency: from_currency,
                      from_amount: from_amount,
                      sendmoney_Nav_node: 2,
                    },
                  })
                }
              >
                Add your first beneficiary
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}